import "./ChatMessage.css";

const ChatMessage = ({ message }) => {
  return (
    <div className={`chat-message ${message.user === "ai" ? "ai" : ""}`}>
      <div className="chat-message-center">
        <div className="message">{message.message}</div>
      </div>
    </div>
  );
};

export default ChatMessage;
